import React, { CSSProperties } from 'react';
import ReactModal from 'react-modal';
import classnames from 'classnames';

interface Props {
  className?: string,
  children?: React.ReactNode,
  disableTouchEvents?: boolean,
  isOpen: boolean,
  large?: boolean,
  onAfterOpen?: () => any,
  onAfterClose?: () => void,
  onRequestClose: (args: any) => void,
  overlayClassName?: string,
  style?: {
    overlay?: CSSProperties,
    content?: CSSProperties,
  },
}

export default function ModalComponent({
  children,
  className,
  disableTouchEvents,
  isOpen,
  onAfterClose,
  onAfterOpen,
  onRequestClose,
  overlayClassName,
  large,
  style,
}: Props) {
  const baseclass = classnames(
    'modal-dialog media--root',
    large && 'modal-dialog--large',
    className,
  );
  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      closeTimeoutMS={150}
      className={{
        base: baseclass,
        afterOpen: 'modal-dialog--after-open',
        beforeClose: 'modal-dialog--before-close',
      }}
      overlayClassName={{
        base: classnames('modal-dialog__overlay', overlayClassName),
        afterOpen: 'modal-dialog__overlay--after-open',
        beforeClose: 'modal-dialog__overlay--before-close',
      }}
      style={{
        overlay: {
          ...style?.overlay,
          touchAction: disableTouchEvents ? 'none' : undefined,
        },
        content: {
          ...style?.overlay,
          touchAction: disableTouchEvents ? 'pan-x pan-y' : undefined,
        },
      }}
    >
      {children}
    </ReactModal>
  );
}

